import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { OrdersCoServices } from '../../../services';

/**
 * Generated class for the TpvTicketSelectedPersonsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-orders-select-selected-persons',
  templateUrl: 'orders-select-selected-persons.html',
})
export class OrdersSelectSelectedPersonsPage {

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public ordersCoServices: OrdersCoServices) {
  }

  ionViewDidLoad() {

  }

  updatePersons() {

    if (this.ordersCoServices.keyboard_screen) {//que haya valor
      this.ordersCoServices.tableUpdatePersons(this.ordersCoServices.keyboard_screen);//ponemos nuevo valor
      this.ordersCoServices.keyboard_screen = '';
      this.navCtrl.pop();
    } else {//no hay valor 
      //le ponemos valor anterior
      this.ordersCoServices.tableUpdatePersons(this.ordersCoServices.tables_array[this.ordersCoServices.selected_table_tpv_index].persons);
      this.ordersCoServices.keyboard_screen = '';
      this.navCtrl.pop();
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/orders/orders-select/orders-select-selected/orders-select-selected-persons/orders-select-selected-persons.ts